// auth.guard.ts
import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { firstAccessibleRoute } from '../../features/core/main/resolvers/main.resolver';
import { KeycloakGnService } from '../services/keycloak-gn.service';

export const AuthGuard: CanActivateFn = async (route, state) => {
  const keycloak = inject(KeycloakGnService);

  if (!(await keycloak.isLoggedIn())) {
    await keycloak.login({ redirectUri: window.location.origin + state.url });
    return false;
  }
  console.log('IS LOGGED IN');
  return true;
};

export const rolesGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const keycloak = inject(KeycloakGnService);
  const router = inject(Router);

  const roles = keycloak.instance.realmAccess?.roles || [];
  if (roles.length === 0) {
    return true;
  }

  const routeRoles = route.data['roles'] as string[] | undefined;
  if (!routeRoles || routeRoles.length === 0) {
    return true;
  }

  const hasRoles = routeRoles.every((role) => keycloak.instance.hasRealmRole(role));

  if (!hasRoles) {
    const next = firstAccessibleRoute(keycloak);
    const target = `/core/${next}`;
    // The default home is botting. Sending a user who cannot open it to /404,
    // or back to /, loops. Stay on this route when there is no other home.
    if (next && state.url !== target && !state.url.startsWith(`${target}/`)) {
      router.navigateByUrl(target);
      return false;
    }
    return true;
  }
  return true;
};
